import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import AskQuestion from 'subsys/ask-question';
import Row, { Col } from 'components/row';

import translates from './write-us-i18n.json';

import 'styles/bildcontrol/blocks/_block-write-us.scss';

const classes = new Bem('blockWriteUs');

@I18nHoc(translates)
export default class WriteUsBlock extends Component {
  static propTypes = {
    className: PropTypes.string,
    url: PropTypes.string
  };

  render() {
    const { i18n } = this;
    const { className, url } = this.props;
    const topic = i18n('writeUsH2');
    const description = i18n('writeUsDescription');
    const descriptionAdditionalMain = i18n('textAdditionalMain');

    return (
      <div {...classes({ extra: className })}>
        <Row {...classes('row', 'block')} mtColumn mpColumn>
          <Col {...classes('col', 'info')} allPr={0}>
            <div {...classes('text', 'h2')}><h2 children={topic} /></div>
            <div {...classes('description')}>
              <p {...classes('text')} children={description} />
              <p {...classes('text')} children={descriptionAdditionalMain} />
            </div>
          </Col>
          <Col {...classes('col', 'form')} allPr={0}>
            <AskQuestion
              {...classes('blockAskQuestion')}
              ref={ref => this.myRef = ref}
              controller="support/ask-question/ask-us-question"
              entity="ask_question"
              url={url}
              otherProps={{
                notificationMessageSuccess: i18n('messageSendThankYou'),
                inputPhoneProps: { noLabel: true, noElementBefore: true },
                otherBtnSendProps: { label: i18n('sendText') },
                headerTopic: false,
                additionalMain: false
              }}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
